import { ArrowRight, Phone } from "lucide-react";
import Reveal from "../Reveal";

const HERO_IMG = "/brand/v4/hero.png";

export default function Hero() {
  const goContact = () =>
    document
      .getElementById("contact")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section
      data-testid="hero-section"
      className="relative pt-24 md:pt-28 lg:pt-0 lg:min-h-[100vh] flex items-center overflow-hidden bg-white"
    >
      {/* Background: logo on black (right) */}
      <div className="absolute inset-0 lg:left-[38%] bg-black flex items-center justify-center overflow-hidden">
        <img
          src="/brand/logo.png"
          alt="Master-Bathrooms"
          className="max-w-[85%] max-h-[80%] w-auto h-auto object-contain opacity-95"
        />
        <div className="absolute inset-0 hero-overlay lg:hidden" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full grid lg:grid-cols-12 gap-10 items-center py-24 lg:py-32">
        <Reveal className="lg:col-span-6">
          <div className="bg-white/95 lg:backdrop-blur-xl lg:border lg:border-[#E5E7EB] p-8 md:p-12 lg:p-14 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <span className="brand-rule" />
              <span className="tag-overline">
                Renovatie met meesterschap
              </span>
            </div>

            <h1
              data-testid="hero-title"
              className="text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-[#0A0A0A] uppercase tracking-tight"
            >
              Een badkamer
              <br />
              die <span className="text-[#1E5BC6]">draait</span>
              <br />
              om u.
            </h1>

            <p className="mt-7 text-base md:text-lg text-[#5A5A5A] leading-relaxed max-w-xl font-normal">
              Of u nu droomt van een nieuwe inloopdouche thuis of de toiletten in
              uw bedrijfspand wilt vernieuwen — bij MasterBathrooms maken we het
              eenvoudig. We komen gratis en vrijblijvend bij u langs en bespreken
              alle opties op uw eigen locatie.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={goContact}
                className="btn-primary-mb px-7 py-4 text-xs inline-flex items-center justify-center gap-2"
              >
                Plan gratis adviesgesprek
                <ArrowRight size={16} />
              </button>
              <a
                href="tel:+31687445044"
                data-testid="hero-cta-call"
                className="btn-outline-mb px-7 py-4 text-xs inline-flex items-center justify-center gap-2"
              >
                <Phone size={16} />
                Bel direct
              </a>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-[#E5E7EB] pt-7">
              <Stat n="100%" label="Vrijblijvend" />
              <Stat n="A–Z" label="Ontzorgd" />
              <Stat n="10+ jr" label="Vakmanschap" />
            </div>
          </div>
        </Reveal>

        <div className="hidden lg:block lg:col-span-6" />
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div>
      <div className="text-3xl font-extrabold text-[#0A0A0A] tracking-tight">
        {n}
      </div>
      <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[#5A5A5A] font-semibold">
        {label}
      </div>
    </div>
  );
}
